import { render, staticRenderFns } from "./PlayLink.vue?vue&type=template&id=4d2b71ba&scoped=true"
import script from "./PlayLink.vue?vue&type=script&lang=js"
export * from "./PlayLink.vue?vue&type=script&lang=js"
import style0 from "./PlayLink.vue?vue&type=style&index=0&id=4d2b71ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b71ba",
  null
  
)

export default component.exports